import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

// Only initialize Sentry in production and staging environments
if (process.env.NODE_ENV !== "development") {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    environment: process.env.NODE_ENV,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
        enableLongTask: false,
        enableLongAnimationFrame: false,
      }),
      // Session Replay is not included here — it requires analytics consent
      // and is added lazily via initSentryReplay() after consent is granted.
    ],
    // The backend continues this decision for every request the page makes,
    // so this rate also drives backend span volume.
    denyUrls: [/^chrome-extension:\/\//i, /^moz-extension:\/\//i],
    tracesSampleRate: 0.05,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

let replayInitialized = false;

export function initSentryReplay() {
  if (replayInitialized || process.env.NODE_ENV === "development") return;
  Sentry.addIntegration(Sentry.replayIntegration());
  replayInitialized = true;
}
